import { Badge } from '@radix-ui/themes';

export default Badge;
